import React from 'react';
import './Reviews.css';
import { useNavigate } from 'react-router-dom';

const reviews = [
  {
    name: "Sarah W.",
    review: "Aaron and his team did an amazing job on our new deck. It looks fantastic and completely transformed our backyard. Highly recommended.",
  },
  {
    name: "Mike L.",
    review: "From the first call to the final nail, Classic Fences was professional, on time, and easy to work with. The quality of the fence is outstanding.",
  },
  {
    name: "Joanne P.",
    review: "We had a custom sliding gate installed and it works perfectly. Aaron made sure everything was done exactly how we wanted it. Great experience.",
  },
  {
    name: "Darryl N.",
    review: "Aaron was honest, efficient, and delivered exactly what he promised. The horizontal board fence looks modern and clean. We've had so many compliments.",
  },
  {
    name: "Emily S.",
    review: "Classic Fences built us a solid, beautiful fence that fits our property perfectly. Aaron was a pleasure to deal with — friendly, helpful, and very skilled.",
  },
];

const Reviews = () => {
  const navigate = useNavigate();

  return (
    <div className="reviews-page">

      <div className="reviews-hero">
        <h1>What Homeowners Are Saying</h1>
        <p>Real feedback from customers who trusted Classic Fence and Deck with their outdoor projects.</p>
        <div className="reviews-hero-rating">
          <span className="hero-stars">★★★★★</span>
          <span className="hero-rating-text">5.0 · Trusted by homeowners across Hamilton</span>
        </div>
      </div>

      <div className="reviews-body">
        <div className="reviews-grid">
          {reviews.map((r, i) => (
            <div key={i} className="review-card">
              <div className="review-card-top">
                <div className="reviewer-avatar">{r.name.charAt(0)}</div>
                <div>
                  <p className="reviewer-name">{r.name}</p>
                  <div className="review-stars">★★★★★</div>
                </div>
              </div>
              <p className="review-body">"{r.review}"</p>
            </div>
          ))}
        </div>

        <div className="reviews-cta">
          <div className="reviews-cta-inner">
            <h2>Ready to Join These Happy Customers?</h2>
            <p>Contact Aaron today for a free, no-obligation estimate on your fence or deck project.</p>
            <button className="btn-gold" onClick={() => navigate('/contact')}>Get a Free Estimate</button>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Reviews;
